import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';
const purchases = [{
  name: 'Marcus',
  city: 'Miami',
  minutes: 4
}, {
  name: 'Daniel',
  city: 'Houston',
  minutes: 9
}, {
  name: 'Anthony',
  city: 'Phoenix',
  minutes: 12
}, {
  name: 'Brian',
  city: 'Boston',
  minutes: 17
}, {
  name: 'Kevin',
  city: 'Atlanta',
  minutes: 6
}, {
  name: 'Steven',
  city: 'Dallas',
  minutes: 14
}, {
  name: 'Eric',
  city: 'San Diego',
  minutes: 8
}, {
  name: 'Ryan',
  city: 'Philadelphia',
  minutes: 11
}];
export function LivePurchaseNotification() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    // Initial delay before first show
    const initialTimer = setTimeout(() => setVisible(true), 5000);
    return () => clearTimeout(initialTimer);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed) return;
    // Cycle through notifications
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex(i => (i + 1) % purchases.length);
        setVisible(true);
      }, 600);
    }, 9000);
    return () => clearInterval(cycle);
  }, [dismissed]);
  if (dismissed) return null;
  const current = purchases[index];
  return <AnimatePresence data-id="element-97">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -40,
      y: 0
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -40
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="fixed bottom-5 left-5 z-40 max-w-[320px]" role="status" aria-live="polite" data-id="element-98">
          <div className="bg-dark-card border border-gold/30 rounded-lg shadow-[0_10px_40px_-10px_rgba(0,0,0,0.8),0_0_20px_rgba(212,175,55,0.15)] backdrop-blur-sm" data-id="element-99">
            <div className="flex items-start gap-3 p-3 pr-8 relative" data-id="element-100">
              <div className="flex-shrink-0 mt-0.5" data-id="element-101">
                <CheckCircle className="w-5 h-5 text-gold" data-id="element-102" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-103">
                <p className="text-[11px] text-gold font-semibold uppercase tracking-wider mb-1" data-id="element-104">
                  Verified Purchase
                </p>
                <p className="text-white text-sm leading-snug" data-id="element-105">
                  <span className="font-semibold" data-id="element-106">{current.name}</span> from{' '}
                  <span className="font-semibold" data-id="element-107">{current.city}</span> just
                  purchased <span className="text-gold" data-id="element-108">The Master Code</span>
                </p>
                <p className="text-gray-400 text-xs mt-1" data-id="element-109">
                  {current.minutes} minutes ago
                </p>
              </div>
              <button onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute top-2 right-2 text-gray-500 hover:text-gold transition-colors" data-id="element-110">
                <X className="w-3.5 h-3.5" data-id="element-111" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}